import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://api.estethica22.com/api';

// ngrok's free tier answers browser requests with an HTML warning page unless this header is sent.
// Set on the axios defaults (before any service module calls axios.create) so every instance inherits it.
if (API_URL.includes('ngrok')) {
  axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true';
}
